import { supabase } from "@/integrations/supabase/client";

export async function submitPetVetForm(formType: "research" | "demo", data: unknown) {
  const { data: result, error } = await supabase.functions.invoke("submit-pet-vet-form", { body: { formType, data } });
  if (error) throw error;
  return result as { id: string; whatsappStatus: string };
}
